import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const SupersetPresetsPage = lazy(
    () => import('../components/SupersetPresetsPage')
)

export const SupersetPresetsRoute: RouteObject = {
    path: 'superset-presets',
    element: <SupersetPresetsPage />,
}

export default SupersetPresetsRoute
